export default "__VITE_ASSET__0577a6b8__"